class CareSetManager {
  constructor() {
    this.careSetHandle = 'zestaw-pielegnacyjny-gratis';
    // Free set used to be the regular product; carts from before the switch may still hold it.
    this.legacyCareSetHandle = 'zestaw-pielegnacyjny';
    this.variantId = null;
    this.qualifyingPrefixes = ['stol-', 'biurko-', 'komoda-', 'stolik-kawowy-', 'konsola-', 'szafka-rtv-', 'regal-'];
    this.processing = false;
    this.userRemoved = false;
    this.queued = null;
    this.sections = 'cart-drawer,cart-icon-bubble';
  }

  init() {
    if (typeof fetchConfig === 'undefined' || typeof subscribe === 'undefined') return;

    const config = document.getElementById('care-set-config');
    if (!config?.dataset.variantId) return;

    this.variantId = config.dataset.variantId;

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'care-set-manager') return;
      this.evaluate(event.cartData || event);
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-care-set-remove]')) {
        this.userRemoved = true;
      }
    });

    this.fetchCartAndEvaluate();
  }

  fetchCartAndEvaluate() {
    fetch(routes.cart_url + '.js')
      .then(r => r.json())
      .then(cart => this.evaluate(cart))
      .catch(() => {});
  }

  evaluate = debounce(async (cartData) => {
    if (this.processing) {
      this.queued = cartData;
      return;
    }
    this.processing = true;

    try {
      let cart = cartData;
      if (!cart?.items || !Array.isArray(cart.items)) {
        const r = await fetch(routes.cart_url + '.js');
        cart = await r.json();
      }

      const hasQualifying = cart.items.some(item =>
        item.handle !== this.careSetHandle &&
        this.qualifyingPrefixes.some(p => item.handle?.startsWith(p))
      );

      if (this.findAutoAdded(cart, this.legacyCareSetHandle)) {
        await this.remove(cart, this.legacyCareSetHandle);
        const r = await fetch(routes.cart_url + '.js');
        cart = await r.json();
      }

      const hasCareSet = !!this.findAutoAdded(cart, this.careSetHandle);

      if (!hasQualifying) {
        this.userRemoved = false;
        if (hasCareSet) await this.remove(cart, this.careSetHandle);
        return;
      }

      if (this.userRemoved) return;

      if (hasQualifying && !hasCareSet) {
        await this.add();
      }
    } finally {
      this.processing = false;
      if (this.queued) {
        const q = this.queued;
        this.queued = null;
        this.evaluate(q);
      }
    }
  }, 300);

  async add() {
    try {
      const r = await fetch(routes.cart_add_url, {
        ...fetchConfig('json'),
        body: JSON.stringify({
          id: this.variantId,
          quantity: 1,
          properties: { _auto_added: 'true' },
          sections: this.sections,
          sections_url: window.location.pathname
        })
      });
      const data = await r.json();
      if (data.status === 422) return;

      this.renderDrawer(data.sections);
    } catch (e) {
      console.error('[CareSet] add failed:', e);
    }
  }

  findAutoAdded(cart, handle) {
    return cart.items.find(i =>
      i.handle === handle &&
      i.properties?._auto_added === 'true'
    );
  }

  async remove(cart, handle) {
    const item = this.findAutoAdded(cart, handle);
    if (!item) return;

    try {
      const r = await fetch(routes.cart_change_url, {
        ...fetchConfig('json'),
        body: JSON.stringify({
          line: cart.items.indexOf(item) + 1,
          quantity: 0,
          sections: this.sections,
          sections_url: window.location.pathname
        })
      });
      const data = await r.json();

      this.renderDrawer(data.sections);
    } catch (e) {
      console.error('[CareSet] remove failed:', e);
    }
  }

  renderDrawer(sections) {
    if (!sections) return;

    const drawerEl = document.getElementById('CartDrawer');
    if (drawerEl && sections['cart-drawer']) {
      const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      const newContent = parsed.querySelector('#CartDrawer');
      if (newContent) drawerEl.innerHTML = newContent.innerHTML;
    }

    ['cart-icon-bubble', 'cart-icon-bubble-mobile'].forEach(id => {
      const el = document.getElementById(id);
      if (el && sections['cart-icon-bubble']) {
        const parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        const content = parsed.querySelector('.shopify-section');
        if (content) el.innerHTML = content.innerHTML;
      }
    });

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.toggle('wt-cart--empty', !drawerEl?.querySelector('.cart-item'));
    }
  }
}

(function initCareSetManager() {
  if (typeof fetchConfig === 'undefined' || typeof subscribe === 'undefined') {
    return setTimeout(initCareSetManager, 100);
  }
  window.careSetManager = new CareSetManager();
  window.careSetManager.init();
})();
